import React, { useState } from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionHeader from '../ui/accordion/AccordionHeader';
import AccordionIcon from '../ui/accordion/AccordionIcon';

import CallsDueManagement from './callsDueToday/CallsDueManagement';
import ClaimManagement from './claims/ClaimManagement';
import DarTableManagement from './dar/DarTableManagement';
import FutureAppointmentManagement from './futureAppointments/FutureAppointmentManagement';

import app from '../../app.module.css';

const Home = () => {
    const [expanded, setExpanded] = useState('');

    const onPanelChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    return (
        <div className={app.pageContainer}>
            <div>
                <Accordion
                    expanded={expanded === 'callsDue'}
                    onChange={() => onPanelChange('callsDue')}
                    slotProps={{ transition: { mountOnEnter: true } }}
                    className={app.accordionDivider}>
                    <AccordionSummary
                        expandIcon={<AccordionIcon />}
                        aria-controls="calls-content"
                        id="calls-header">
                        <AccordionHeader>Calls Due Today</AccordionHeader>
                    </AccordionSummary>
                    <AccordionDetails>
                        {expanded === 'callsDue' && <CallsDueManagement />}
                    </AccordionDetails>
                </Accordion>
            </div>
            <div>
                <Accordion
                    expanded={expanded === 'darRequests'}
                    onChange={() => onPanelChange('darRequests')}
                    slotProps={{ transition: { mountOnEnter: true } }}
                    className={app.accordionDivider}>
                    <AccordionSummary
                        expandIcon={<AccordionIcon />}
                        aria-controls="dar-content"
                        id="dar-header">
                        <AccordionHeader>Data Amendment Requests</AccordionHeader>
                    </AccordionSummary>
                    <AccordionDetails>
                        {expanded === 'darRequests' && <DarTableManagement />}
                    </AccordionDetails>
                </Accordion>
            </div>
            <div>
                <Accordion
                    expanded={expanded === 'claims'}
                    onChange={() => onPanelChange('claims')}
                    slotProps={{ transition: { mountOnEnter: true } }}
                    className={app.accordionDivider}>
                    <AccordionSummary
                        expandIcon={<AccordionIcon />}
                        aria-controls="claims-content"
                        id="claims-header">
                        <AccordionHeader>Claims</AccordionHeader>
                    </AccordionSummary>
                    <AccordionDetails>
                        {expanded === 'claims' && <ClaimManagement />}
                    </AccordionDetails>
                </Accordion>
            </div>
            <div>
                <Accordion
                    expanded={expanded === 'futureAppointments'}
                    onChange={() => onPanelChange('futureAppointments')}
                    slotProps={{ transition: { mountOnEnter: true } }}
                    className={app.accordionDivider}>
                    <AccordionSummary
                        expandIcon={<AccordionIcon />}
                        aria-controls="appointment-content"
                        id="appointment-header">
                        <AccordionHeader>Future Appointments</AccordionHeader>
                    </AccordionSummary>
                    <AccordionDetails>
                        {expanded === 'futureAppointments' && <FutureAppointmentManagement />}
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
};

export default Home;
